import Phaser from 'phaser';
import { assetsToPreload } from '../assets-to-load';
import { app } from '../core/App';
import BaseScene from '../core/scenes/BaseScene';
import { SceneId, TransitionPoint } from '../app-routing';

export default class Boot extends BaseScene {
  constructor() {
    super('Boot');
  }

  preload() {
    app.beforePreload();
    super.preload();
    assetsToPreload(this);
  }

  create() {
    super.create();

    if (!__IS_PRODUCTION__) this.scene.launch(SceneId.DebugUI, { test: 'test' });
    app.gotoNextScene(this, TransitionPoint.BootEnd, { test: 'test' });
  }
}
